/*
 * @Description: file content
 * @Author: wangalong
 * @Date: 2022-04-24 14:19:58
 * @LastEditTime: 2022-11-02 10:36:25
 */
import { callKBApp } from './use-call-kbapp'

// 在开吧(Flutter环境内)
export const isFlutterKbApp =
    /(kb_flutter)/i.test(window.navigator.userAgent) || /(kb_dsbridge_flutter)/i.test(window.navigator.userAgent)

// 在开吧(iOS环境内)
export const isIOSKbApp =
    /(kb_ios)/i.test(window.navigator.userAgent) || (isFlutterKbApp && /(iPhone)/i.test(window.navigator.userAgent))

// 在开吧(安卓环境内)
export const isAndroidKbApp =
    /(kb_android)/i.test(window.navigator.userAgent) ||
    /(kb_dsbridge_android)/i.test(window.navigator.userAgent) ||
    (isFlutterKbApp && !isIOSKbApp)

// 开吧app网页内
export const isKbApp = isIOSKbApp || isAndroidKbApp || isFlutterKbApp

// 微信公众号内
export const isWechat = window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1

// 手机/PC 内置浏览器内(非开吧,非微信)
export const isBrowser = !isKbApp && !isWechat

/**
 * @param {() => void} callback
 */
export function onBrowser(callback) {
    return isBrowser && callback()
}

/**
 * @param {() => void} callback
 */
export function onWechat(callback) {
    return isWechat && callback()
}

/**
 * @param {() => void} callback
 */
export function onKbApp(callback) {
    return isKbApp && callback()
}

/**
 * 不在开吧app内
 * @param {() => void} callback
 */
export function notonKbApp(callback) {
    return !isKbApp && callback()
}

/**
 * @param {() => void} callback
 */
export function onIOSKbApp(callback) {
    return isIOSKbApp && callback()
}

/**
 * @param {() => void} callback
 */
export function onAndroidKbApp(callback) {
    return isAndroidKbApp && callback()
}

/**
 * @description 装饰器.包装只能在开吧app中执行的某些方法
 */
export function decorateOnlyInKbApp<ICallback extends (...params: any[]) => any>(callback: ICallback): ICallback
export function decorateOnlyInKbApp<ICallback extends (...params: any[]) => any>(url: string, callback?: ICallback): ICallback
export function decorateOnlyInKbApp<ICallback extends (...params: any[]) => any>(params1: string | ICallback, params2?: ICallback) {
    return function() {
        const url = typeof params1 === 'string' ? params1 : window.location.href
        const callback = typeof params1 === 'function' ? params1 : params2

        if (process.env.NODE_ENV === 'development') {
            console.error('触发打开app操作, 当前为开发模式,模拟通过')
            return callback?.apply(this, arguments)
        }

        if (!isKbApp) {
            callKBApp({ action: 'pageWeb', actionParams: { url } })

            throw new Error('请在开吧app中打开')
        }

        return callback?.apply(this, arguments)
    }
}
